module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/notifications-1-8d074ed221d7350e642e716421861203.svg";